import { connectApi } from "@api/coreApi";
import { baseURL } from "@api/endpoints";

export const getVideoList = ({ access_code, id }) =>
  connectApi({
    method: "GET",
    url: `${baseURL.getWorkshopVideoList}?workshop_id=${id}&workshop_access_code=${access_code}`,
  });

export const submitVideoAnswer = (payload) =>
    connectApi({
    method: "POST",
    url: baseURL.submitWorkshopVideoAnswer,
    payload,
});